import _ from "lodash";
import { colors } from "@toddle-edu/ds-theme";
import React from "react";
import MediaPlaceholder from "UIComponents/MediaPlaceholder";

export const JournalPreviewCard = props => {
  const {
    attachment,
    cardStyle,
    containerStyle,
    itemStyles,
    mode = "view",
    isStudentResponse,
    onClickMedia,
  } = props;

  /* const onClickMedia = ({ event } = {}) => {
    if (event && event.stopPropagation) event.stopPropagation();
    setShowMediaModal(true);
  };*/
  const { isPost, attachments = [], id } = attachment;
  return (
    <MediaPlaceholder
      onClickMedia={onClickMedia}
      mode={mode}
      isDisabledMode={false}
      attachments={isPost ? attachments : [attachment]}
      imageMaxHeight={_.get(cardStyle, "height", 284)}
      imageMaxWidth={284}
      resolutionMutliplier={2}
      showOverlayIcons={false}
      scalableRatio={1}
      itemStyles={{
        borderRadius: "4px",
        backgroundColor: colors.white,
        ...(itemStyles || {}),
      }}
      containerStyle={{
        height: "284px",
        flex: "1 0 0",
        width: "284px",
        ...(containerStyle || {}),
      }}
      noteContainerStyle={{ padding: 0 }}
      showDownloadIcon={false}
      isAttachmentCreated={true}
      isStudentResponse={isStudentResponse}
      showIconCardsWithExtension={true}
      showExtensionOnCornerByHover={true}
      showMiddleContainerIcons={_.get(attachment, "type") == "VIDEO"}
    />
  );
};
